import { render, staticRenderFns } from "./vendorBankDetailsDashboard.vue?vue&type=template&id=591ec0cf&scoped=true&"
import script from "./vendorBankDetailsDashboard.vue?vue&type=script&lang=js&"
export * from "./vendorBankDetailsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ec0cf",
  null
  
)

export default component.exports